import React from 'react';
import { ModuleT } from 'business/constants';
import { useTranslation } from 'react-i18next';
import { camelize } from 'helpers/syntaxHelper';
import ModuleForbidden from './ModuleForbidden';

type Props = {
    module: ModuleT;
    hasModule: boolean;
    isModuleUser: boolean;
    children?: React.ReactNode;
};

export const ModuleWithRolesCheck = ({
    module,
    hasModule,
    isModuleUser,
    children = <></>,
}: Props) => {
    const { t } = useTranslation();

    const title = t('moduleForbidden.title', {
        module: t(`modules.${camelize(module)}`),
    });

    const description = t('moduleForbidden.description', {
        module: t(`modules.${camelize(module)}`),
    });

    return (
        <>
            {hasModule && isModuleUser ? (
                children
            ) : (
                <ModuleForbidden title={title} description={description} />
            )}
        </>
    );
};
